import React from "react";
import "./Modal.scss";

const Modals = ({ isOpen, onClose, title, description }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          ✖
        </button>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default Modals;
